import _ from "lodash";

import murid from './murid';

const routes = [
	...murid.map(o => _.assign({ list_model: ["murid"] }, o)),
];
export default routes;